export default "__VITE_ASSET__BTlFbRQK__"